<template>
  <van-uploader :after-read="afterRead">
    <van-cell is-link :border="false">
      <!-- 使用 title 插槽来自定义标题 -->
      <img class="header-img" :src="userInfo.fileKey" />
      <template #title>
        <span class="header-span-name">头像</span>
      </template>
    </van-cell>
  </van-uploader>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  data() {
    return {
      fileList: {}, //
      imgInfo: {} //上传图片到服务器返回的图片信息
    };
  },
  created() {},
  methods: {
    // 上传文件完成的回调
    afterRead(file) {
      console.log(file);
      this.fileList = file;
      this.afterImgRead(file);
      file.status = "uploading";
      file.message = "上传中...";
    },
    // 图片上传成功回调
    afterImgRead(file) {
      var obj = { file: file.file };
      this.centralControl.axios.centralControl(
        "uploadFile",
        res => {
          const { data = {}, code, message } = res;
          if (code == "200") {
            this.imgInfo = data;
            this.$set(this.userInfo, "fileKey", data.temporaryUrl);
            this.$emit("changeFileKey", data.fileKey);
            file.status = "success";
            file.message = "上传成功";
            console.log(data);
          } else {
            file.status = "failed";
            file.message = "上传失败";
            toast(this, res.message, "error");
          }
        },
        obj
      );
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';

.header-span-name {
  font-size: 14px;
}

.header-img {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  margin-left: 15px;
}
</style>